// notificationMixin.js
export const notificationMixin = {
  methods: {
    playNotificationSound() {
      const audio = new Audio('/sounds/notification1.wav')
      audio.play().catch((e) => console.error('Error al reproducir el sonido de notificación:', e))
    },
  },
}
